import {
  getAuth,
  linkWithPopup,
  linkWithRedirect,
  GoogleAuthProvider,
  unlink,
} from 'firebase/auth';
import { User } from 'firebase/auth';
import { logError, logInfo } from '@/utils/logger'; // Import the logger functions

const provider = new GoogleAuthProvider();

const linkAccount = () => {
  const auth = getAuth();
  logInfo('Auth instance created', 'linkAccount', auth);
  if (!auth.currentUser) return;
  logInfo('User exists', 'linkAccount', auth.currentUser);
  linkWithPopup(auth.currentUser, provider)
    .then((result) => {
      // Accounts successfully linked.
      const credential = GoogleAuthProvider.credentialFromResult(result);
      const user = result.user;
      logInfo('Credential obtained', 'linkAccount', credential);
      // ...
    })
    .catch((error) => {
      // Handle Errors here.
      logError(error, 'linkAccount');
      // ...
    });
};

// const linkAccountRedirect = () => {
//   const auth = getAuth();
//   if (!auth.currentUser) return
//   logInfo('User exists', 'linkAccountRedirect', auth.currentUser);
//   linkWithRedirect(auth.currentUser, provider)
//     .then(/* ... */)
//     .catch(/* ... */);
// }

const unlinkAccount = () => {
  const auth = getAuth();
  if (!auth.currentUser) return;
  const providerId = GoogleAuthProvider.PROVIDER_ID;
  logInfo('Auth instance exists', 'unlinkAccount', auth);
  unlink(auth.currentUser, providerId)
    .then((value) => {
      // Auth provider unlinked from account
      logInfo('Unlinked successfully', 'unlinkAccount', value);
      // ...
    })
    .catch((error) => {
      // An error happened
      logError(error, 'unlinkAccount');
      // ...
    });
};

export { linkAccount, unlinkAccount };

// Sets the authenticated user and stores their authentication token in session storage.
export const setUserAndAuthToken = async (
  user: User,
  setUser: (user: User | null) => void,
): Promise<void> => {
  try {
    // Retrieve the ID token for the authenticated user from Firebase.
    const token = await user.getIdToken(true);

    // Store the token in session storage for subsequent requests.
    sessionStorage.setItem('authToken', token);

    // Update the user state in the authentication context.
    setUser(user);
  } catch (error) {
    // Log any errors that occur during the token retrieval and state update process.
    logError(error, 'setUserAndAuthToken');

    // Handle the error by resetting the user state and clearing session and local storage.
    setUser(null);
    sessionStorage.clear();
    localStorage.clear();
  }
};
